/**
 * Botones de respuesta rápida en la burbuja (docs/SEGUIMIENTO.md §2.10, bloque 4) — lo puro.
 *
 * Dos lecturas sobre el documento del mensaje, sin React:
 *   · `botonesOfrecidos(msg)`: las opciones que llevaba un SALIENTE (`meta.botones.opciones`,
 *     escritas por `persistirSaliente` vía `enviarMensajeNucleo`).
 *   · `botonElegido(msg)`: el botón que un ENTRANTE respondió (`respuestaBoton`, escrito por
 *     `messageRouter`: por id del webhook o por mapeo de texto).
 * Devuelven formas estables aunque el documento venga viejo o a medias.
 *
 * CommonJS a propósito (como `timezoneMap.js` y `ventanaDeAtencion.js`): CRA interopera
 * `module.exports`, y así el test vive en `functions/__tests__/`, que es la puerta que corre
 * en el pre-commit. Un test en `src/` no protegería nada (CLAUDE.md).
 */
function botonesOfrecidos(msg) {
  const ops = msg && msg.meta && msg.meta.botones && msg.meta.botones.opciones;
  if (!Array.isArray(ops)) return [];
  return ops.filter((o) => o && typeof o.texto === 'string' && o.texto).map((o) => ({ id: String(o.id == null ? '' : o.id), texto: o.texto }));
}

function botonElegido(msg) {
  const r = msg && msg.respuestaBoton;
  if (!r || !r.id) return null;
  return { id: String(r.id), texto: typeof r.texto === 'string' ? r.texto : '', origen: r.origen || null };
}

module.exports = { botonesOfrecidos, botonElegido };
